<template>
  <div class="login-page" style="overflow-x:hidden ">
    <NavHeader
      :status="{
        page:'login',
        produce:false,
        solution:false
      }"
    ></NavHeader>
    <loginCard
      :isSignIn="true"
      ref="signIn"
      @loginSuccess="loginSuccess"
      class="login-card"
      >
    </loginCard>
  </div>
</template>

<script>
import loginCard from '@/components/loginCard'
import NavHeader from '@/components/NavHeader'
import {removeToken} from "@/utils/auth";
export default {
  name: 'login',
  components:{
    NavHeader,
    loginCard
  },
  data(){
    return{

      //控制卡片显隐
      showLoginCard:this.$route.query.way==='登录',


      device:'账号',
      signWay:''



    }
  },
  created () {

    if(this.$route.query.way==="注册"){
      this.signWay='注册'
      this.device='手机'
    }
    else {
      this.signWay='登录'
    }


      if(!localStorage.getItem('uid')){
          removeToken()
        localStorage.clear()
          //this.$router.go(0)
      }
  },
  mounted () {
    if(this.$route.query.info){
      this.$message.error(this.$route.query.info)
    }

    this.signWay=this.$route.query.way
  },
  methods:{
    loginSuccess(){
      setTimeout(()=>{
        // this.$router.push({name:'home',params:{account:arguments[0]}})
        this.$router.push('/home')
      },500)
    },
    createSuccess(){
      setTimeout(()=>{
        this.$router.push({name:'home',params:{account:arguments[0]}})
      },500)
    },

  }
}
</script>

<style scoped>
.login-page{
  width: 100vw;
  height: 100vh;
  background-image: url("http://data.xiyilab.com/web/main/static/login/图层6.png");
  background-position: top;
  background-repeat: no-repeat;
  background-size: cover ;
  overflow: hidden;
}
.login-card{
  width: 23vw;
  height: 32vw;
  margin-top: 11vw;
  margin-left: 60vw;
  margin-bottom: 12vw;
}
</style>
